import { Coordinates } from "@evergis/sgis/es/baseTypes";

export const getCoordinate = (rawCoordinate: string): number => +rawCoordinate.replace(",", ".").trim();

export const isCoordinates = (value: string) => /^[\s\d;,.]{5,}$/.test(value);

export const getCoordinates = (value: string): Coordinates | [] => {
  // Simple check to prevent next calculations
  if (!isCoordinates(value)) {
    return [];
  }

  // eslint-disable-next-line no-useless-escape
  const rawCoordinates = value.match(/-?([1-8]?[1-9]|[1-9]0)+((\.|\,){1}\d{1,})?/g);

  if (!rawCoordinates || rawCoordinates.length !== 2) {
    return [];
  }

  const [x, y] = rawCoordinates.map(getCoordinate);

  if (Number.isNaN(x) || Number.isNaN(y) || x > 180 || x < 0 || y < -90 || y > 90) {
    return [];
  }

  return [x, y];
};
